export default __webpack_public_path__ + "static/media/feather.753e9762.ttf";